import styled from '@emotion/styled';
import MuiButton from '@mui/material/Button';

const CreateAccountButton = styled(MuiButton)({
    cursor: 'pointer',
    fontFamily: 'Ambit, sans-serif',
    fontSize: '.875rem',
    height: '1.35rem',
    padding: 0,
    textTransform: 'none',
    letterSpacing: 0,
});

export default CreateAccountButton;
